module.exports = __webpack_public_path__ + "static/media/clear_night.34423838.svg";